import type { IconProps } from "./icon-types";

/**
 * 단일 media frame. 네 모서리 bracket은 frame viewport의 경계를 나타낸다.
 *
 * [[AnnotationIcon]]과 같은 바깥 silhouette를 사용하되 내부 annotation marker를 비워,
 * annotation이 없는 frame과 있는 frame을 한 icon family 안에서 구분할 수 있게 한다.
 */
export const FrameIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M8 4H5a1 1 0 0 0-1 1v3" />
    <path d="M16 4h3a1 1 0 0 1 1 1v3" />
    <path d="M20 16v3a1 1 0 0 1-1 1h-3" />
    <path d="M8 20H5a1 1 0 0 1-1-1v-3" />
  </svg>
);
